import {
  getV1RutterConnectionsConnectionIdCustomers,
  GetV1RutterConnectionsConnectionIdCustomersData,
  Rutter_Customer_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { RutterCustomer, RutterMappedRecord } from '~hooks/useRutter/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Rutter_Customer_Read,
  RutterMappedRecord,
  GetV1RutterConnectionsConnectionIdCustomersData
> & { companyId: string; connectionId: string };

// Offers only the QuickBooks customers not yet mapped to a Tread account.
export default function AutocompleteRutterCustomersTypeahead<T extends FieldValues>({
  companyId,
  connectionId,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      queryName="AutocompleteRutterCustomersTypeahead"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId, 'connection-id': connectionId },
          query: { 'filter[unmapped]': true },
        },
        request: getV1RutterConnectionsConnectionIdCustomers,
      }}
      filterOptions={(options) => options.filter(({ _entity }) => _entity.isActive)}
      parseFn={(item: Rutter_Customer_Read) => {
        const customer = RutterCustomer.parse(item);
        const name = customer.rutterApiCustomer.customer_name ?? '';

        return {
          _entity: new RutterMappedRecord(customer.id, name, customer.isActive),
          label: name,
          value: customer.id,
        };
      }}
    />
  );
}
